import { ReactElement, useEffect } from "react";

import { Link } from "react-router-dom";

import Card from "@mui/material/Card";
import CardActionArea from "@mui/material/CardActionArea";
import CardContent from "@mui/material/CardContent";
import Grid from "@mui/material/Grid";
import Stack from '@mui/material/Stack';
import Typography from "@mui/material/Typography";

import CopyrightIcon from "@mui/icons-material/Copyright";
import HandshakeIcon from "@mui/icons-material/Handshake";
import LockIcon from "@mui/icons-material/Lock";

import GratiPageWrapper from "../components/common/GratiPageWrapper";
import { useApp } from "../contextProviders/AppProvider";

export default function AboutPage(): ReactElement {
  const { setPageName, updateActions } = useApp();

  useEffect(() => {
    setPageName("About");
    updateActions([]);
  }, [setPageName, updateActions]);

  return (
    <GratiPageWrapper isAuthRequired={false} isNoAuthRequired={false}>
      <Stack sx={{
        maxWidth: "md"
      }}>
        <Typography gutterBottom variant="headline">
          Gratisports policies
        </Typography>
        <Typography
          variant="bodyLarge"
          sx={{
            color: "text.secondary",
            mb: 4,
            textAlign: "center"
          }}>
          We are committed to protecting your data and privacy while delivering services that consistently
          delight you. The policies below outline how we handle your information and the terms that govern
          our relationship. We encourage you to review them carefully.
        </Typography>
        <Grid container spacing={3} sx={{
          justifyContent: "center"
        }}>
          <Grid size={{ xs: 12, sm: 4 }}>
            <Card
              sx={{
                height: "100%",
                backgroundColor: "primary.main",
                color: "primary.contrastText",
              }}
            >
              <CardActionArea component={Link} to="/privacy" sx={{ height: "100%" }}>
                <CardContent sx={{ textAlign: "center", py: 4 }}>
                  <LockIcon sx={{ fontSize: 48, mb: 2 }} />
                  <Typography variant="titleMedium">Privacy</Typography>
                </CardContent>
              </CardActionArea>
            </Card>
          </Grid>

          <Grid size={{ xs: 12, sm: 4 }}>
            <Card
              sx={{
                height: "100%",
                backgroundColor: "secondary.main",
                color: "secondary.contrastText",
              }}
            >
              <CardActionArea component={Link} to="/terms" sx={{ height: "100%" }}>
                <CardContent sx={{ textAlign: "center", py: 4 }}>
                  <HandshakeIcon sx={{ fontSize: 48, mb: 2 }} />
                  <Typography variant="titleMedium">Terms of Use</Typography>
                </CardContent>
              </CardActionArea>
            </Card>
          </Grid>

          <Grid size={{ xs: 12, sm: 4 }}>
            <Card
              sx={{
                height: "100%",
                backgroundColor: "tertiary.main",
                color: "tertiary.contrastText",
              }}
            >
              <CardActionArea component={Link} to="/copyright" sx={{ height: "100%" }}>
                <CardContent sx={{ textAlign: "center", py: 4 }}>
                  <CopyrightIcon sx={{ fontSize: 48, mb: 2 }} />
                  <Typography variant="titleMedium">Copyright</Typography>
                </CardContent>
              </CardActionArea>
            </Card>
          </Grid>
        </Grid>
      </Stack>
    </GratiPageWrapper>
  );
}
